import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=135d1c54&scoped=true&"
import script from "./PartnerView.vue?vue&type=script&lang=ts&"
export * from "./PartnerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d1c54",
  null
  
)

export default component.exports